import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';

@Directive({ selector: '[cnCountUp]', standalone: true })
export class CountUpDirective implements OnInit, OnDestroy {
  @Input('cnCountUp')     to      = 0;
  @Input() cnCountUpFrom          = 0;
  @Input() cnCountUpDecimals      = 0;
  @Input() cnCountUpDuration      = 2000;
  @Input() cnCountUpPrefix        = '';
  @Input() cnCountUpSuffix        = '';

  private observer?: IntersectionObserver;
  private raf?: number;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit() {
    this.el.nativeElement.textContent = this.format(this.cnCountUpFrom);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.el.nativeElement.textContent = this.format(this.to);
      return;
    }

    this.observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        this.observer?.disconnect();
        this.run();
      }
    }, { threshold: 0.5 });
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.observer?.disconnect();
    if (this.raf) cancelAnimationFrame(this.raf);
  }

  private run() {
    const start = performance.now();
    const from  = this.cnCountUpFrom;
    const range = this.to - from;
    const step = (now: number) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / this.cnCountUpDuration, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      this.el.nativeElement.textContent = this.format(from + range * eased);
      if (progress < 1) this.raf = requestAnimationFrame(step);
    };
    this.raf = requestAnimationFrame(step);
  }

  private format(v: number): string {
    const n = this.cnCountUpDecimals > 0
      ? v.toFixed(this.cnCountUpDecimals)
      : Math.round(v).toString();
    return `${this.cnCountUpPrefix}${n}${this.cnCountUpSuffix}`;
  }
}
